import { useCheckPermissions } from '../shared';

export const usePermissionAllowed = (
  permissions: SpPermission | SpPermission[]
): boolean => {
  const permissionResults = useCheckPermissions(permissions);

  return permissionResults.some(result => result.allowed);
};
